export class LowDpiHelper {
  private static readonly VECTOR_EXTENSIONS = ["svg", "eps", "pdf", "ai"];

  public static readonly isVectorImage = (filename?: string) => {
    if (!filename) return false;
    const ext = filename.slice(filename.lastIndexOf(".") + 1).toLowerCase();
    return this.VECTOR_EXTENSIONS.includes(ext);
  };

  public static readonly getDpiText = (dpi?: number) => {
    if (!dpi) return;

    if (dpi < 250) {
      return "This image has a poor resolution, this will likely impact the print results.";
    }

    if (dpi < 300) {
      return "This image is below our recommended resolution which may impact print results.";
    }
  };

  public static readonly calculateDpi = (params: {
    heightInches?: number | string | null;
    heightPixels?: number;
    widthInches?: number | string | null;
    widthPixels?: number;
  }) => {
    let { heightInches, widthInches } = params;
    const { heightPixels, widthPixels } = params;

    heightInches = heightInches ? Number(heightInches) : undefined;
    widthInches = widthInches ? Number(widthInches) : undefined;

    if (!widthPixels || !heightPixels || !widthInches || !heightInches) {
      return undefined;
    }

    if (Number.isNaN(widthInches) || Number.isNaN(heightInches)) {
      return undefined;
    }

    const dpiWidth = widthPixels / widthInches;
    const dpiHeight = heightPixels / heightInches;
    return Math.min(dpiHeight, dpiWidth);
  };
}
